import { AppLayout } from "components/app-layout";
import {
  AgencySettingsProvider,
  type AgencySettingsLoaderData,
} from "contexts/agency-settings-provider";
import { RequireAuthRole } from "contexts/auth-provider";
import { PropertyTenancyProvider } from "contexts/property-tenancy-provider";
import type { Route } from "lib/react-router-dom";
import { LeftNavigation } from "modules/landlord-portal/components/left-navigation";
import { LANDLORD_PORTAL_PATHS } from "modules/landlord-portal/paths";
import { OverviewScreen } from "modules/landlord-portal/screens/overview/overview-screen";

export const LANDLORD_PORTAL_ROUTES: Route[] = [
  {
    id: "landlord-root",
    path: LANDLORD_PORTAL_PATHS.DEFAULT,
    handle: {
      title: "Landlord",
    },
    loader: (): AgencySettingsLoaderData => ({
      agencySettings: Promise.resolve({
        branding: {
          agency_name: null,
          primary_logo: null,
          secondary_logo: null,
          accent_color: "",
          navigation_color: "",
          heading_font: null,
          heading_font_family: null,
          body_font: null,
          body_font_family: null,
        },
      }),
    }),
    element: (
      <RequireAuthRole anyOf={["landlord", "agent", "agent_manager"]}>
        <AgencySettingsProvider>
          <PropertyTenancyProvider>
            <AppLayout leftNavigationMenu={<LeftNavigation />} />
          </PropertyTenancyProvider>
        </AgencySettingsProvider>
      </RequireAuthRole>
    ),
    children: [
      {
        index: true,
        Component: OverviewScreen,
        handle: {
          title: "Overview",
        },
      },
    ],
  },
];

/**
 * TODO: the remaining children list routes for landlord-portal
 *       WIP if this will be included
 *
 * export const LANDLORD_PORTAL_ROUTES: Route[] = [
 *     children: [
 *       {
 *         path: LANDLORD_PORTAL_PATHS.MAINTENANCE,
 *         Component: MaintenanceScreen,
 *         handle: {
 *           title: "Maintenance",
 *         },
 *       },
 *       {
 *         path: LANDLORD_PORTAL_PATHS.INSPECTIONS,
 *         Component: InspectionsScreen,
 *         handle: {
 *           title: "Inspections",
 *         },
 *       },
 *       {
 *         path: LANDLORD_PORTAL_PATHS.INSPECTION_DETAILS,
 *         Component: InspectionDetailsScreen,
 *         handle: {
 *           title: "Inspection Details Screen",
 *         },
 *       },
 *       {
 *         path: LANDLORD_PORTAL_PATHS.FINANCIALS,
 *         Component: FinancialsScreen,
 *         handle: {
 *           title: "Financials",
 *         },
 *       },
 *       {
 *         path: LANDLORD_PORTAL_PATHS.DOCUMENTS,
 *         Component: DocumentsScreen,
 *         handle: {
 *           title: "Documents",
 *         },
 *       },
 *     ],
 *   },
 * ];
 */
